import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { ICurrencyCard } from "@app/models/storyblok/blocks/currency-card";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { RichText } from "../../models";
import { CurrencyCard } from "./components/currency-card/CurrencyCard";

type Props = {
  title?: RichText;
  currencyCards: ICurrencyCard[];
};

export const SwitchCurrencies: FC<Props> = ({ title, currencyCards }) => (
  <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
    <div
      className={classNames(
        "mt-20 px-5",
        "lg:mt-25 lg:px-16",
        "xl:mt-40 xl:px-24",
      )}
    >
      <div className={classNames("max-w-container space-y-15", "xl:mx-auto")}>
        {title ? (
          <BlockHeader
            richText={title}
            className={classNames(
              "text-medium text-primary-content",
              "md:text-large",
              "xl:mx-auto xl:max-w-[980px] xl:text-center xl:text-xx-large",
            )}
          />
        ) : null}
        <div
          className={classNames(
            "grid grid-cols-1 gap-10",
            "md:grid-cols-2",
            "lg:grid-cols-3",
            "xxl:gap-11",
          )}
        >
          {currencyCards.map((block) => (
            <CurrencyCard key={block.link.url ?? block.link.id} {...block} />
          ))}
        </div>
      </div>
    </div>
  </Fade>
);
